// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ProductionResource extends TrackingModel {
	public ProductionResourceId: number = 0;
	public ProductionId: number = 0;
	public ResourceId: number = 0;
	public ResourceTypeId?: number;
}